import styled from 'styled-components';

export default styled.div`
	line-height: normal;
	--filter-size: 3.8rem;
	--gap: var(--spacing-x-large);
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: var(--gap);
	.instruction-text {
		display: flex;
		flex-direction: column;
	}
	.buttons-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.filter-container {
			display: flex;
			flex-direction: column;
		}
	}
`;
